import Table from 'semantic-ui-react/dist/commonjs/collections/Table'
import styled from 'styled-components'

const BorderlessTableCell = styled(Table.Cell)`
&&& {
  border: 0 !important;
}
`

export default BorderlessTableCell
